<template>
  <div>


    <vs-popup title="Les preuves" :active.sync="preuves" class="items-no-padding">
      <input type="file" class="hidden" ref="updateImgInput1" @change="updateCurrImg1" multiple accept="image/*">

      <div v-if="!detail__detail" class="upload-img mt-5 mb-2">
        <vs-button icon-pack="feather" icon="icon-plus" @click="$refs.updateImgInput1.click()">Preuves</vs-button>
      </div>

      <div class="carousel-example" v-if="dataImg1.length || (input.pathPictures && input.pathPictures.length)">
        <swiper :options="swiperOption" style="height: 300px !important;">
          <swiper-slide v-for="(data, io) in dataImg1" :key="io + '458'" @click="delete_preuve(io)">
            <div class="items-center justify-center">
              <vs-button
                v-if="!detail__detail"
                icon-pack="feather"
                icon="icon-trash"
                size="small"
                color="warning"
                @click="delete_carte_identite(io)"
              >Supprimer</vs-button>
              <img style="height: 300px !important;" class="responsive" :src="data" alt="banner">
            </div>
          </swiper-slide>

          <swiper-slide v-for="(data, io) in input.pathPictures" :key="io + '45895'" @click="delete_preuve({ id: data.id, key: io })">
            <div class="items-center justify-center">
              <vs-button
                v-if="!detail__detail"
                icon-pack="feather"
                icon="icon-trash"
                size="small"
                color="warning"
                @click="delete_carte_identite({ id: data.id, key: io })"
              >Supprimer</vs-button>
              <img style="height: 300px !important;" class="responsive" :src="$store.state.image_url +  data.url" alt="banner">
            </div>
          </swiper-slide>
          
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>

      <vs-button class="mt-5" icon-pack="feather" icon="icon-check" @click="preuves = false">ok</vs-button>
    </vs-popup>
    
    <vs-popup title="Ajouter un nouveau colis" :active.sync="ouvert" class="items-no-padding">
      <div v-if="input.typeOfPath !== 5 && input.typeOfPath !== 2">
        <p>Colis <b style="color: #ff6141" >*</b> </p>
        <v-select class="w-full" label="name" v-model="input_interne.packaging" :options="packagings"></v-select>

        <p class="mt-5" >Agent <b style="color: #ff6141" >*</b> </p>
        <v-select class="w-full" label="full_name" v-model="input_interne.user" :options="userList"></v-select>
      </div>

      <div v-if="input.typeOfPath == 5">
        <p >Provenance <b style="color: #ff6141" >*</b> </p>
        <v-select class="w-full" label="libelle" v-model="input_interne.purchase" :options="purchases"></v-select>

        <div v-if="input_interne.purchase">
          <vs-list-item icon-pack="feather" icon="icon-check" title="Poids disponible" :subtitle="String(input_interne.purchase.remainingWeight)"></vs-list-item>
          <vs-list-item icon-pack="feather" icon="icon-check" title="Nombre de sac disponible" :subtitle="String(input_interne.purchase.remainingQuantity)"></vs-list-item>
        </div>
      </div>

      <div v-if="input.typeOfPath == 2">
        <p class="mt-5" >Provenance <b style="color: #ff6141" >*</b> </p>
        <v-select class="w-full" label="libelle" v-model="input_interne.traceability" :options="traceabilitys"></v-select>

        <div v-if="input_interne.traceability">
          <vs-list-item icon-pack="feather" icon="icon-check" title="Poids disponible" :subtitle="String(input_interne.traceability.weight)"></vs-list-item>
          <vs-list-item icon-pack="feather" icon="icon-check" title="Nombre de sac disponible" :subtitle="String(input_interne.traceability.quantity)"></vs-list-item>
        </div>
      </div>

      
      <p class="mt-5" >Poids (KG)<b style="color: #ff6141" >*</b> </p>
      <vs-input-number class="w-full" v-model="input_interne.weight"/>

      <vs-alert :active="inputValid_weight" color="danger" icon-pack="feather" icon="icon-info">
        <span>Veuillez saisir un poid inférieur au <b>poid disponible</b>.</span>
      </vs-alert>

      <p class="mt-5" >Quantité <b style="color: #ff6141" >*</b> </p>
      <vs-input-number class="w-full" v-model="input_interne.quantity"/>

      <vs-alert :active="inputValid_quantity" color="danger" icon-pack="feather" icon="icon-info">
        <span>Veuillez saisir un nombre inférieur ou égal au <b>nombre de sac disponible disponible</b>.</span>
      </vs-alert>

      <vs-button  v-if="inputValid_weight || inputValid_quantity" class="mt-5" icon-pack="feather" icon="icon-check" disabled>Valider</vs-button>
      <vs-button v-if="!inputValid_weight && !inputValid_quantity" class="mt-5" icon-pack="feather" icon="icon-check" @click="validerFonction()">Valider</vs-button>
    </vs-popup>

    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>{{ detail__detail? 'DÉTAIL DU' : (Object.entries(this.data).length === 0 ? "NOUVEAU" : "MODIFIER LE") }} TRAJET</h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"/>
        </div>
        <vs-divider class="mb-0" />
        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
            <div class="px-6 py-2" v-if="!detail__detail">
              <!-- {{typeOfPaths}} -->
                <vs-button type="border" class="mt-5" icon-pack="feather" icon="icon-image" @click="preuves = true">Preuves</vs-button>
              
                <p class="mt-5" >Type de trajet <b style="color: #ff6141" v-if="!detail__detail" >*</b> </p>
                <v-select :disabled="detail__detail" 
                  :reduce="rep => rep.id" class="w-full" label="name" v-model="input.typeOfPath" :options="typeOfPaths"></v-select>
                <span v-if="error.typeOfPath || all_errors.typeOfPath.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                  <p v-for="(err, io) in all_errors.typeOfPath" :key="io" style="margin-bottom: 4px !important; font-size: 13px">{{err}}</p>
                </span>
                
                <div v-if="input.typeOfPath !== 1">
                  <p class="mt-5" >Lieu de départ <b style="color: #ff6141" v-if="!detail__detail" >*</b> </p>
                  <v-select :disabled="detail__detail" 
                    :reduce="rep => rep.id" class="w-full" label="name" v-model="input.departurePlace" :options="villages"></v-select>
                  <span v-if="error.departurePlace || all_errors.departurePlace.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                    <p v-for="(err, io) in all_errors.departurePlace" :key="io" style="margin-bottom: 4px !important; font-size: 13px">{{err}}</p>
                  </span>
                </div>

                <div v-if="input.typeOfPath !== 2">
                  <p class="mt-5" >Destination <b style="color: #ff6141" v-if="!detail__detail" >*</b> </p>
                  <v-select :disabled="detail__detail" 
                    :reduce="rep => rep.id" class="w-full" label="name" v-model="input.arrivalPlace" :options="villages"></v-select>
                  <span v-if="error.arrivalPlace || all_errors.arrivalPlace.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                    <p v-for="(err, io) in all_errors.arrivalPlace" :key="io" style="margin-bottom: 4px !important; font-size: 13px">{{err}}</p>
                  </span>
                </div>

                <p class="mt-5" >Date de chargement<b style="color: #ff6141" v-if="!detail__detail" >*</b> </p>
                <datepicker :disabled="detail__detail" v-model="input.startDate"></datepicker>
                <span v-if="error.startDate || all_errors.startDate.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                  <p v-for="(err, io) in all_errors.startDate" :key="io" style="margin-bottom: 4px !important; font-size: 13px">{{err}}</p>
                </span>

                <p class="mt-5" >Nom complet du chauffeur <b style="color: #ff6141">*</b> </p>
                <vs-input 
                  :disabled="detail__detail"
                  :danger="error.driverFull_name || all_errors.driverFull_name.length ? true : false"
                  v-model="input.driverFull_name" class="w-full" name="item-code" />
                <span v-if="error.driverFull_name || all_errors.driverFull_name.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                  <p v-for="(err, io) in all_errors.driverFull_name" :key="io" style="margin-bottom: 4px !important; font-size: 13px">{{err}}</p>
                </span>

                <p class="mt-5" >Immatriculation de la voiture <b style="color: #ff6141">*</b> </p>
                <vs-input
                  :disabled="detail__detail"
                  :danger="error.truckNumber || all_errors.truckNumber.length ? true : false"
                  v-model="input.truckNumber" class="w-full" name="item-code" />
                <span v-if="error.truckNumber || all_errors.truckNumber.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                  <p v-for="(err, io) in all_errors.truckNumber" :key="io" style="margin-bottom: 4px !important; font-size: 13px">{{err}}</p>
                </span>

                <!-- <p class="mt-5" >Date de déchargement<b style="color: #ff6141" v-if="!detail__detail" >*</b> </p>
                <datepicker :disabled="detail__detail" v-model="input.endDate"></datepicker>
                <span v-if="error.endDate || all_errors.endDate.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                  <p v-for="(err, io) in all_errors.endDate" :key="io" style="margin-bottom: 4px !important; font-size: 13px">{{err}}</p>
                </span> -->

                <vs-button type="border" class="mt-5" icon-pack="feather" icon="icon-plus" @click="ouvert = true">Ajouter un colis</vs-button>
                
            </div>

            <vs-list v-if="detail__detail">
              <vs-list-header icon-pack="feather" icon="icon-truck" title="Information"></vs-list-header>
              
              <vs-list-item icon-pack="feather" icon="icon-check" title="État du trajet">
                <vs-chip :color="getOrderStatusColor(input.is_active)" class="product-order-status">{{ input.is_active ? 'En cours' : 'Clôturé' }}</vs-chip>
              </vs-list-item>
              <vs-list-item icon-pack="feather" icon="icon-check" title="Type de trajet" :subtitle="input.typeOfPath.name"></vs-list-item>
              <vs-list-item v-if="input.departurePlace" icon-pack="feather" icon="icon-check" title="Lieu de départ" :subtitle="input.departurePlace.name"></vs-list-item>
              <vs-list-item v-if="input.arrivalPlace" icon-pack="feather" icon="icon-check" title="Destination" :subtitle="input.arrivalPlace.name"></vs-list-item>
              <vs-list-item icon-pack="feather" icon="icon-check" title="Date de chargement" :subtitle="convertDateTime(new Date(input.startDate)).date"></vs-list-item>

              <vs-list-item icon-pack="feather" icon="icon-check" title="Nom complet du chauffeur" :subtitle="input.driverFull_name"></vs-list-item>
              <vs-list-item icon-pack="feather" icon="icon-check" title="Immatriculation de la voiture" :subtitle="input.truckNumber"></vs-list-item>

              <vs-list-item icon-pack="feather" icon="icon-check" title="Date de déchargement" :subtitle="input.is_active ? 'Aucun' : convertDateTime(new Date(input.endDate)).date"></vs-list-item>

              <!-- ...  *{{input.pathHasPackagings}}*  ... -->
              <!-- {{input.typeOfPath}} -->
              <vs-list-header icon-pack="feather" icon="icon-dollar-sign" title="Frais total du trajet" color="primary"></vs-list-header>
              <vs-list-item icon-pack="feather" icon="icon-dollar-sign" :title="String(input.totalFee.amount__sum ? input.totalFee.amount__sum : '')">
              </vs-list-item>

              <div v-if="input.typeOfPath.id == 5 || input.typeOfPath.id == 2">
                <vs-list-header icon-pack="feather" icon="icon-box" title="Colis total du trajet" color="warning"></vs-list-header>
                <vs-list-item icon-pack="feather" icon="icon-shield" title="Soja" :subtitle="String(input.totalWeight.weight__sum ? input.totalWeight.weight__sum : '') + ' KG [ ' + String(input.totalQuantity.quantity__sum ? input.totalQuantity.quantity__sum : '0') + ' sac(s) ]'">
                  <vs-chip v-if="input.typeOfPath.id == 2" :color="getOrderStatusColor(!input.alert)" class="product-order-status">  <h4 style="color: white;"> Contre pesée: {{ input.againstWeighing }} KG</h4> </vs-chip>
                </vs-list-item>
              </div>

              <!-- <vs-list-item v-for="(item, ioj) in input.pathHasPackagings" :key="ioj" icon-pack="feather" icon="icon-shield" :title="item.packaging.name" :subtitle="String(item.quantity) + ' (Quantité)'">
                <vs-chip :color="getOrderStatusColor(!input.path[ioj].alert)" class="product-order-status">  <h4 style="color: white;"> Contre pesée: {{ input.path[ioj].againstWeighing }} </h4> </vs-chip>
              </vs-list-item> -->
            </vs-list>

            <vs-list>
              <vs-list-header v-if="input.pathHasPackagings.length" icon-pack="feather" icon="icon-box" title="Colis détail" color="success"></vs-list-header>
              <div v-for="(item, ioj) in input.pathHasPackagings" :key="ioj" class="pathHasPackagings">
                
                <vs-list-item icon-pack="feather" icon="icon-shopping-bag" :title="item.packaging.name" :subtitle="String(item.weight) + ' KG [ ' + String(item.quantity) + ' sac(s) ]'">
                  <vx-tooltip text="Supprimer" color="danger">
                    <feather-icon
                      v-if="!detail__detail"
                      @click="pathHasPackagings_delete(item, ioj)"
                      style="color: red"
                      icon="TrashIcon"
                      svgClasses="w-5 h-5 hover:text-danger stroke-current"
                      class="mr-2"
                    />
                  </vx-tooltip>
                </vs-list-item>

                <!-- <vs-list-item icon-pack="feather" icon="icon-shopping-cart" title="Achat" :subtitle="item.purchase.libelle">
                  <vs-chip color="gray"> <b> {{item.user.full_name}} (Agent) </b> </vs-chip>
                </vs-list-item> -->

                <div v-if="input.typeOfPath == 5 || input.typeOfPath == 2">
                  <vs-list-item icon-pack="feather" icon="icon-shopping-cart" title="Provenance" :subtitle="item.purchase ? (item.purchase.libelle + ' (Achat)') : (item.traceability ? (item.traceability.libelle  + ' (Traçabilité)') : '')">
                    <!-- <vs-chip color="gray"> <b> {{item.user.full_name}} (Agent) </b> </vs-chip> -->
                  </vs-list-item>
                </div>

                <div v-if="input.typeOfPath != 5 && input.typeOfPath != 2">
                  <vs-list-item icon-pack="feather" icon="icon-user-plus" title="Agent" :subtitle="item.user.full_name">
                  </vs-list-item>
                </div>
              </div>
            </vs-list>
        </VuePerfectScrollbar>
        <div v-if="!detail__detail" class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Soumettre</vs-button>
            <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Annuler</vs-button>
        </div>
    </vs-sidebar>
  </div>
</template>

<script>
    var base_self;
    var input_tempon = {
      id: null,
      typeOfPath: '',
      departurePlace: '',
      wording: '',
      startDate: '',
      // endDate: '',
      arrivalPlace: '',
      pathHasPackagings_delete: [],
      pathHasPackagings: [
        /* {
          packaging: { id: 1, name: 'Packaging A' },
          quantity: 500
        },
        {
          packaging: { id: 1, name: 'Packaging B' },
          quantity: 700
        } */
      ],
      driverFull_name: '',
      truckNumber: '',
    };
    
    import 'swiper/dist/css/swiper.min.css'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'

    import Datepicker from 'vuejs-datepicker';
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';


    export default {
        components: {VuePerfectScrollbar, Datepicker, swiper, swiperSlide},
        props: {
            isSidebarActive: {
              type: Boolean,
              required: true
            },
            data: {
              type: Object,
              default: () => {},
            },
        },
        data() {
            return {
              inputValid_weight: false,
              inputValid_quantity: false,
              dataImg1: [],
              dataImg1_delete: [],
              dataImg1_file: [],
              userList: [],
              purchases: [],
              input_interne: {
                packaging: '',
                user: '',
                weight: 0,
                quantity: 0,
                purchase: '',
                traceability: ''
              },
              input_interne1: {
                packaging: '',
                user: '',
                weight: 0,
                quantity: 0,
                purchase: '',
                traceability: ''
              },
              ouvert: false,
              preuves: false,
              counterDanger: false,
              swiperOption: {
                spaceBetween: 30,
                centeredSlides: true,
                autoplay: {
                  delay: 2500,
                  disableOnInteraction: false
                },
                pagination: {
                  el: '.swiper-pagination',
                  clickable: true
                },
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev'
                }
              },
              initialNoError: {
                typeOfPath: false,
                departurePlace: false,
                wording: false,
                arrivalPlace: false,
                startDate: false,
                driverFull_name: false,
                truckNumber: false,
                endDate: false,
              },
              error: {
                typeOfPath: false,
                departurePlace: false,
                wording: false,
                arrivalPlace: false,
                startDate: false,
                driverFull_name: false,
                truckNumber: false,
                endDate: false,
              },
                all_errors: {
                  name: [],
                  typeOfPath: [],
                  departurePlace: [],
                  wording: [],
                  arrivalPlace: [],
                  startDate: [],
                  driverFull_name: [],
                  truckNumber: [],
                  endDate: [],
                },
                typeOfPaths: [],
                villages: [],
                packagings: [],
                traceabilitys: [],
                input: JSON.parse(JSON.stringify(input_tempon)),
                input1: JSON.parse(JSON.stringify(input_tempon)),
                detail__detail: false,
                settings: { // perfectscrollbar settings
                    maxScrollbarLength: 60,
                    wheelSpeed: .60,
                },
            }
        },
        computed: {
            isSidebarActiveLocal: {
                get() {
                    return this.isSidebarActive
                },
                set(val) {
                    if(!val) {
                        this.$emit('closeSidebar')
                    }
                }
            },
            isFormValid() {
              var is_valide = true;
              if (!this.input.startDate || this.input.startDate === '') is_valide = false;
              if (!this.input.driverFull_name || this.input.driverFull_name === '') is_valide = false;
              if (!this.input.truckNumber || this.input.truckNumber === '') is_valide = false;
              // if (!this.input.endDate || this.input.endDate === '') is_valide = false;
              if (this.input.startDate > this.input.endDate) is_valide = false;
              if (!base_self.input.typeOfPath || base_self.input.typeOfPath === '') is_valide = false;
              if ((!base_self.input.departurePlace || base_self.input.departurePlace === '') && base_self.input.typeOfPath !== 1) is_valide = false;
              if ((!base_self.input.arrivalPlace || base_self.input.arrivalPlace === '') && base_self.input.typeOfPath !== 2) is_valide = false;
              if (!base_self.input.pathHasPackagings.length) is_valide = false;

              if (base_self.input.id) {
                if (!base_self.dataImg1.length && !base_self.input.pathPictures) is_valide = false;
              } else {
                if (!base_self.dataImg1.length) is_valide = false;
              }
              
              return is_valide;
            }
        },
        methods: {
          async Erreur(message) {
            this.$vs.dialog({
              type:'confirm',
              color: 'danger',
              title: 'Erreur',
              text: message,
              acceptText: 'OK',
              //cancelText: 'Annuler',
              /* accept: async () => {
                base_self.$store.state.path_delete(id)
                  .then ((response) => {
                    window.getAgroTrack.success('Le trajet est supprimée avec succès.', response);
                    base_self.getPaths();
                  })
                  .catch(() => {
                    window.getAgroTrack.error({ message: 'La suppression du trajet a échouée.' });
                  });
              } */
            })
          },
            getOrderStatusColor(status) {
              if(status) return "success"
              return "danger"
            },
            addElement (element, libelle) {
              base_self[libelle].push(element);
            },
            deleteElement (id, libelle) {
              const length = base_self[libelle].length

              for (let i = 0; i < length; i++) {
                if (base_self[libelle][i].id === id) {
                  base_self[libelle].splice(i, 1);
                  break;
                }
              }
            },
            async validerFonction () {
              base_self.input.pathHasPackagings.push(JSON.parse(JSON.stringify(base_self.input_interne)));

              if (base_self.input_interne.purchase) {
                base_self.deleteElement(base_self.input_interne.purchase.id, 'purchases');
              }

              if (base_self.input_interne.traceability) {
                base_self.deleteElement(base_self.input_interne.traceability.id, 'traceabilitys');
              }

              base_self.input_interne1 = {
                packaging: '',
                user: '',
                weight: 0,
                quantity: 0,
                purchase: '',
                traceability: ''
              };
              
              base_self.input_interne = {
                packaging: '',
                user: '',
                weight: 0,
                quantity: 0,
                purchase: '',
                traceability: ''
              };

              base_self.ouvert = false
            },
            async pathHasPackagings_delete (tr, iou) {
              if (tr.id_gene) {
                base_self.input.pathHasPackagings_delete.push(tr.id_gene);
              }   
              
              if (!tr.id_gene && tr.purchase) {
                base_self.addElement(tr.purchase, 'purchases');
              }

              if (!tr.id_gene && tr.traceability) {
                base_self.addElement(tr.traceability, 'traceabilitys');
              }

              base_self.input.pathHasPackagings.splice(iou, 1);
              base_self.input = JSON.parse(JSON.stringify(base_self.input));
            },
            async getPackagings () {
              let reponse = await base_self.$store.state.packagings({})
              base_self.packagings = reponse.data.results
            },
            async getUserList () {
              let reponse = await base_self.$store.state.userList({})
              base_self.userList = reponse.data
            },
            async getPath_traceabilities(user) {
              let reponse = await base_self.$store.state.path_traceabilities({user})
              base_self.traceabilitys = reponse.data

              console.log('base_self.traceabilitys: ', base_self.traceabilitys);
            },
            async getPath_purchases(user) {
              let reponse = await base_self.$store.state.path_purchases({user})
              base_self.purchases = reponse.data

              console.log('base_self.purchases: ', base_self.purchases);
            },
            async getTypeOfPaths () {
              let reponse = await base_self.$store.state.typeOfPaths({})
              base_self.typeOfPaths = reponse.data.results

              console.log(' :::::::::::::::::::::::::::::::::::::::::::::::::::::::::base_self.typeOfPaths: ');
              console.log(' :::::::::::::::::::::::::::::::::::::::::::::::::::::::::base_self.typeOfPaths: ');
              console.log(' :::::::::::::::::::::::::::::::::::::::::::::::::::::::::base_self.typeOfPaths: ');
              console.log(' :::::::::::::::::::::::::::::::::::::::::::::::::::::::::base_self.typeOfPaths: ');
              console.log(' :::::::::::::::::::::::::::::::::::::::::::::::::::::::::base_self.typeOfPaths: ');
              console.log(' :::::::::::::::::::::::::::::::::::::::::::::::::::::::::base_self.typeOfPaths: ');
              console.log('base_self.typeOfPaths: ', base_self.typeOfPaths);
              console.log(' !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!base_self.typeOfPaths! ');
              console.log(' !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!base_self.typeOfPaths! ');
              console.log(' !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!base_self.typeOfPaths! ');
              console.log(' !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!base_self.typeOfPaths! ');
              console.log(' !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!base_self.typeOfPaths! ');
              console.log(' !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!base_self.typeOfPaths! ');
            },
            async getVillages () {
              let reponse = await base_self.$store.state.villages({})
              base_self.villages = reponse.data.results
            },
            verification_startDate_endDate () {
              let libelle1 = 'La date de début doit être inférieur à la date de déchargement.';
              if (base_self.input.startDate > base_self.input.endDate){
                if (!base_self.all_errors.endDate.find(element => element === libelle1)) {
                  base_self.all_errors.endDate.push(libelle1)
                }

                if (!base_self.all_errors.startDate.find(element => element === libelle1)) {
                  base_self.all_errors.startDate.push(libelle1)
                }
              } else {
                base_self.all_errors.endDate = base_self.all_errors.endDate.filter(e => e !== libelle1);
                base_self.all_errors.startDate = base_self.all_errors.startDate.filter(e => e !== libelle1);
              }
            },
            verification_driverFull_name () {
              let libelle = 'Le nom est réquis.';
              if (!base_self.initialNoError.driverFull_name) return false;
              if (base_self.input.driverFull_name.length === 0) {
                base_self.all_errors.driverFull_name.push(libelle)
              } else {
                base_self.all_errors.driverFull_name = base_self.all_errors.driverFull_name.filter(e => e !== libelle);
              }
            },
            verification_truckNumber () {
              let libelle = 'Le nom est réquis.';
              if (!base_self.initialNoError.truckNumber) return false;
              if (base_self.input.truckNumber.length === 0) {
                base_self.all_errors.truckNumber.push(libelle)
              } else {
                base_self.all_errors.truckNumber = base_self.all_errors.truckNumber.filter(e => e !== libelle);
              }
            },
            verification_startDate () {
              let libelle = 'La date de début est réquise.';
              if (!base_self.initialNoError.startDate) return false;
              if (base_self.input.startDate.length === 0) {
                base_self.all_errors.startDate.push(libelle)
              } else {
                base_self.all_errors.startDate = base_self.all_errors.startDate.filter(e => e !== libelle);
              }

              base_self.verification_startDate_endDate();
            },
            verification_endDate () {
              let libelle = 'La date de fin est réquise.';
              if (!base_self.initialNoError.endDate) return false;
              if (base_self.input.endDate.length === 0) {
                base_self.all_errors.endDate.push(libelle)
              } else {
                base_self.all_errors.endDate = base_self.all_errors.endDate.filter(e => e !== libelle);
              }

              base_self.verification_startDate_endDate();
            },
            /* verification_wording () {
              let libelle = 'La description est réquise.';
              if (!base_self.initialNoError.wording) return false;
              if (base_self.input.wording.length === 0) {
                base_self.all_errors.wording.push(libelle)
              } else {
                base_self.all_errors.wording = base_self.all_errors.wording.filter(e => e !== libelle);
              }
            }, */
            verification_typeOfPath () {
              let libelle = 'Le type de trajet est réquis.';
              if (!base_self.initialNoError.typeOfPath) return false;
              if (!base_self.input.typeOfPath || base_self.input.typeOfPath === '') {
                base_self.all_errors.typeOfPath.push(libelle)
              } else {
                base_self.all_errors.typeOfPath = base_self.all_errors.typeOfPath.filter(e => e !== libelle);
              }
            },
            verification_departurePlace () {
              let libelle = 'Le gardien est réquis.';
              if (!base_self.initialNoError.departurePlace) return false;
              if (!base_self.input.departurePlace || base_self.input.departurePlace === '') {
                base_self.all_errors.departurePlace.push(libelle)
              } else {
                base_self.all_errors.departurePlace = base_self.all_errors.departurePlace.filter(e => e !== libelle);
              }
            },
            verification_arrivalPlace () {
              let libelle = 'Le montant est réquis.';
              if (!base_self.initialNoError.arrivalPlace) return false;
              if (!base_self.input.arrivalPlace || base_self.input.arrivalPlace === '') {
                base_self.all_errors.arrivalPlace.push(libelle)
              } else {
                base_self.all_errors.arrivalPlace = base_self.all_errors.arrivalPlace.filter(e => e !== libelle);
              }
            },
            convertDateTime (dateTimeSysteme) {
              // return new Promise((resolve, reject) => {
              let date = dateTimeSysteme.getFullYear() + '-' + ('0' + (dateTimeSysteme.getMonth() + 1)).slice(-2) + '-' + ('0' + dateTimeSysteme.getDate()).slice(-2);
              // let date = ('0' + dateTimeSysteme.getDate()).slice(-2) + '-' + ('0' + (dateTimeSysteme.getMonth() + 1)).slice(-2) + '-' + dateTimeSysteme.getFullYear();
              let time = ('0' + dateTimeSysteme.getHours()).slice(-2) + ':' + ('0' + dateTimeSysteme.getMinutes()).slice(-2) + ':' + ('0' + dateTimeSysteme.getSeconds()).slice(-2);
              let dateTime = date + ' ' + time;

              return { dateTime, date, time };
              // resolve({ dateTime, date, time });
              // });
            },
            updateCurrImg1(input) {
              if (input.target.files && input.target.files[0]) {
                let length = input.srcElement.files.length;
                for (let iuoy = 0; iuoy < length; iuoy++) {
                  var reader = new FileReader();
                  reader.onload = e => {
                    // unshift
                    base_self.dataImg1.unshift(e.target.result)
                    base_self.dataImg1_file.unshift(base_self.$refs.updateImgInput1.files[iuoy])

                  };
                  reader.readAsDataURL(input.target.files[iuoy])
                }	
              }
            },
            async delete_carte_identite(data) {
              if (data.id) {
                base_self.dataImg1_delete.push(data.id);
                base_self.input.pathPictures.splice(data.key, 1);
              } else {
                base_self.dataImg1.splice(data.key, 1);
              }
            },
            async delete_preuve(data) {
              this.$vs.dialog({
                type:'confirm',
                color: 'danger',
                title: 'Confirmation',
                text: 'Confirmer la suppression?',
                acceptText: 'Confirmer',
                cancelText: 'Annuler',
                accept: async () => {
                  if (data.id) {
                    base_self.dataImg1_delete.push(data.id);
                    base_self.input.pathPictures.splice(data.key, 1);
                  } else {
                    base_self.dataImg1.splice(data.key, 1);
                  }
                }
              })
            },
            async submitData() {
                let convertDateTime = function (dateTimeSysteme) {
                  // return new Promise((resolve, reject) => {
                  let date = dateTimeSysteme.getFullYear() + '-' + ('0' + (dateTimeSysteme.getMonth() + 1)).slice(-2) + '-' + ('0' + dateTimeSysteme.getDate()).slice(-2);
                  // let date = ('0' + dateTimeSysteme.getDate()).slice(-2) + '-' + ('0' + (dateTimeSysteme.getMonth() + 1)).slice(-2) + '-' + dateTimeSysteme.getFullYear();
                  let time = ('0' + dateTimeSysteme.getHours()).slice(-2) + ':' + ('0' + dateTimeSysteme.getMinutes()).slice(-2) + ':' + ('0' + dateTimeSysteme.getSeconds()).slice(-2);
                  let dateTime = date + ' ' + time;

                  return { dateTime, date, time };
                  // resolve({ dateTime, date, time });
                  // });
                };

                var input = JSON.parse(JSON.stringify(this.input));

                input.startDate = convertDateTime(new Date(input.startDate)).date;
                input.endDate = convertDateTime(new Date(input.endDate)).date;

                let iuo = 0;
                for (iuo = 0; iuo < input.pathHasPackagings.length; iuo++) {
                  if (!input.pathHasPackagings[iuo].id_gene) {
                    input.pathHasPackagings[iuo].packaging = input.pathHasPackagings[iuo].packaging.id;
                    input.pathHasPackagings[iuo].user = input.pathHasPackagings[iuo].user.id;
                    input.pathHasPackagings[iuo].quantity = Number(input.pathHasPackagings[iuo].quantity);
                    input.pathHasPackagings[iuo].weight = Number(input.pathHasPackagings[iuo].weight);

                    if (input.pathHasPackagings[iuo].purchase) {
                      input.pathHasPackagings[iuo].purchase = input.pathHasPackagings[iuo].purchase.id;
                    }

                    if (input.pathHasPackagings[iuo].traceability) {
                      input.pathHasPackagings[iuo].traceability = input.pathHasPackagings[iuo].traceability.id;
                    }
                  } else {
                    input.pathHasPackagings.splice(iuo, 1);
                    iuo--;
                  }
                }

                console.log(' ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: ');
                console.log('input: ', input);
                console.log(' ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: ');
                input.pathHasPackagings = JSON.stringify(input.pathHasPackagings)
                input.pathHasPackagings_delete = JSON.stringify(input.pathHasPackagings_delete)
                ///===========================================================================
                var form = new FormData()
                
                const keys = ['typeOfPath', 'departurePlace', 'wording', 'startDate', 'arrivalPlace', 'pathHasPackagings_delete', 'pathHasPackagings', 'driverFull_name', 'truckNumber'];
                var length = keys.length;
                var iuoy = 0;
                for (iuoy = 0; iuoy < length; iuoy++) {
                  var item = keys[iuoy];
                  form.append(item, input[item]);
                }

                if (base_self.dataImg1_delete.length) {
                  length = base_self.dataImg1_delete.length;
                  for (iuoy = 0; iuoy < length; iuoy++) {
                    form.append("pictures_remove", base_self.dataImg1_delete[iuoy]);
                  }	
                }

                if (base_self.dataImg1_file.length) {
                  length = base_self.dataImg1_file.length;
                  for (iuoy = 0; iuoy < length; iuoy++) {
                    if (input.id) {
                      form.append("pictures_add", base_self.dataImg1_file[iuoy], base_self.dataImg1_file[iuoy].name);
                    } else {
                      form.append("proof", base_self.dataImg1_file[iuoy], base_self.dataImg1_file[iuoy].name);
                    }
                  }
                } 
                ///===========================================================================

                console.log('form: ', form);
                
                if(!input.id) {     
                    base_self.$store.state.path_post(form)
                      .then((response) => { 
                        window.getAgroTrack.success('Le trajet est ajouté avec succès.', response);
                        window.getAppPaths.getPaths();
                        this.$emit('closeSidebar');
                        this.initValues()
                      })
                      .catch((error) => { 
                        console.log('error: ', error)
                      });
                  
                } else if (input.id) {
                    console.log(' 99999iiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii99 ');
                    base_self.$store.state.path_update(form, input.id)
                      .then((response) => { 
                        window.getAgroTrack.success('Le trajet est modifié avec succès.', response);
                        window.getAppPaths.getPaths();
                        this.$emit('closeSidebar');
                        this.initValues()
                      })
                      .catch((error) => { 
                        console.log('error: ', error)
                      });
                }
            },
            initValues() {
                this.initialNoError = {
                  typeOfPath: false,
                  departurePlace: false,
                  wording: false,
                  arrivalPlace: false,
                  startDate: false,
                  endDate: false,
                  driverFull_name: false,
                  truckNumber: false,
                };
                base_self.input = JSON.parse(JSON.stringify(input_tempon));
                base_self.input1 = JSON.parse(JSON.stringify(input_tempon));
                base_self.detail__detail = false;
                base_self.dataImg1 = [];
                base_self.dataImg1_delete = [];
                base_self.dataImg1_file = [];
                // window.getPaths.sidebarData.detail__detail = false;
            }
        },
        watch: {
          input_interne: {
            handler () {
              if (base_self.input_interne.purchase && base_self.input_interne.purchase.id !== base_self.input_interne1.purchase.id) {
                console.log('base_self.input_interne.purchase: ', base_self.input_interne.purchase)
                
                base_self.input_interne.weight = base_self.input_interne.purchase.remainingWeight
                base_self.input_interne.quantity = base_self.input_interne.purchase.remainingQuantity
              }

              if (base_self.input_interne.traceability && base_self.input_interne.traceability.id !== base_self.input_interne1.traceability.id) {
                console.log('base_self.input_interne.traceability: ', base_self.input_interne.traceability)
                
                base_self.input_interne.weight = base_self.input_interne.traceability.weight
                base_self.input_interne.quantity = base_self.input_interne.traceability.quantity
              }

              if (base_self.input_interne.purchase && base_self.input_interne.weight > base_self.input_interne.purchase.remainingWeight) {
                // base_self.input_interne.weight = base_self.input_interne.purchase.remainingWeight
                base_self.inputValid_weight = true
              } else {
                base_self.inputValid_weight = false
              }

              if (base_self.input_interne.purchase && base_self.input_interne.quantity > base_self.input_interne.purchase.remainingQuantity) {
                // base_self.input_interne.quantity = base_self.input_interne.purchase.remainingQuantity
                base_self.inputValid_quantity = true
              } else {
                base_self.inputValid_quantity = false
              }

              if (base_self.input_interne.traceability && base_self.input_interne.weight > base_self.input_interne.traceability.remainingWeight) {
                base_self.inputValid_weight = true
              } else {
                base_self.inputValid_weight = false
              }

              if (base_self.input_interne.traceability && base_self.input_interne.quantity > base_self.input_interne.traceability.remainingQuantity) {
                base_self.inputValid_quantity = true
              } else {
                base_self.inputValid_quantity = false
              }

              base_self.input_interne1 = JSON.parse(JSON.stringify(base_self.input_interne));
            },
            deep: true
          },
          input: {
            handler () {
              if (base_self.input1.startDate !== base_self.input.startDate) 
              {
                base_self.initialNoError.startDate = true
                base_self.verification_startDate()
              }

              if (base_self.input1.endDate !== base_self.input.endDate) 
              {
                base_self.initialNoError.endDate = true
                base_self.verification_endDate()
              }

              /* if (base_self.input1.wording !== base_self.input.wording) 
              {
                base_self.initialNoError.wording = true
                base_self.verification_wording()
              } */

              if (base_self.input1.typeOfPath !== base_self.input.typeOfPath) 
              {
                base_self.initialNoError.typeOfPath = true
                base_self.verification_typeOfPath()
              }

              if (base_self.input1.departurePlace !== base_self.input.departurePlace) 
              {
                base_self.initialNoError.departurePlace = true
                base_self.verification_departurePlace()
              }

              if (base_self.input1.driverFull_name !== base_self.input.driverFull_name) 
              {
                base_self.initialNoError.driverFull_name = true
                base_self.verification_driverFull_name()
              }

              if (base_self.input1.truckNumber !== base_self.input.truckNumber) 
              {
                base_self.initialNoError.truckNumber = true
                base_self.verification_truckNumber()
              }

              if (base_self.input1.arrivalPlace !== base_self.input.arrivalPlace) 
              {
                base_self.initialNoError.arrivalPlace = true
                base_self.verification_arrivalPlace()
              }
              base_self.input1 = JSON.parse(JSON.stringify(base_self.input));
            },
            deep: true
          },
          async isSidebarActive() {
              base_self.getPath_purchases()
              base_self.getPath_traceabilities()
              this.initValues();
              if (base_self.data && base_self.data.id) {
                // Object.assign(base_self.input, JSON.parse(JSON.stringify(base_self.data)));
                
                let response = await base_self.$store.state.paul_post({ path: base_self.data.id });
                let pathHasPackagings = [];

                console.log(' :::::::::::::::::::::::::::::::::::::: response: !!!!!!!!!!!!!!!!!!!!!!!!!!!! ');
                console.log(' :::::::::::::::::::::::::::::::::::::: response: !!!!!!!!!!!!!!!!!!!!!!!!!!!! ');
                console.log(' :::::::::::::::::::::::::::::::::::::: response: !!!!!!!!!!!!!!!!!!!!!!!!!!!! ');
                console.log(' :::::::::::::::::::::::::::::::::::::: response: !!!!!!!!!!!!!!!!!!!!!!!!!!!! ');
                console.log('response: ', response);

                for (let uio = 0; uio < response.data.length; uio++) {
                  let item = response.data[uio];

                  pathHasPackagings.push({
                    id_gene: item.id,
                    packaging: item.packaging,
                    user: item.user,
                    quantity: item.quantity,
                    weight: item.weight,
                    purchase: item.purchase,
                    traceability: item.traceability
                  });
                }

                base_self.input = JSON.parse(JSON.stringify(base_self.data));
                base_self.input.pathHasPackagings = pathHasPackagings;
                base_self.input.pathHasPackagings_delete = [];
                base_self.input = JSON.parse(JSON.stringify(base_self.input));

                base_self.input.startDate = new Date(base_self.input.startDate);
                base_self.input.endDate = new Date(base_self.input.endDate);
                

                console.log('base_self.input: ', base_self.input);
                console.log('base_self.input.pathHasPackagings.length: ', base_self.input.pathHasPackagings.length);
              }

              if (base_self.data.detail__detail) {
                base_self.detail__detail = true;
              }
          }
        },
        created() {
          window.EditCategory = this;
          base_self = this;
          base_self.initValues()
          base_self.getVillages()
          base_self.getPackagings()
          base_self.getTypeOfPaths()
          base_self.getUserList()
        }

    }
</script>

<style>
.pathHasPackagings {
  border: 1px solid #9bbb00;
  border-radius: 5px;
}
</style>


<style lang="scss" scoped>
    .add-new-data-sidebar {
        ::v-deep .vs-sidebar--background {
            z-index: 52010;
        }

        ::v-deep .vs-sidebar {
            z-index: 52010;
            width: 400px;
            max-width: 90vw;

            .img-upload {
                margin-top: 2rem;

                .con-img-upload {
                    padding: 0;
                }

                .con-input-upload {
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }

    .scroll-area--data-list-add-new {
        // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
        height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
        
    }
</style>